import Vue from "vue";
import App from "./App.vue";

import appConfigPlugin from "@/plugins/appsync/appConfigPlugin";

import VTiptap from "@peepi/vuetify-tiptap";

import "@aws-amplify/ui-vue";
import {
  applyPolyfills,
  defineCustomElements,
} from "@aws-amplify/ui-components/loader";

import { Amplify, Auth, AuthModeStrategyType, DataStore } from "aws-amplify";
import awsconfig from "./aws-exports";
import { ConsoleLogger } from "@aws-amplify/core";

import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import { vuetify, i18n } from "./plugins/vuetify/vuetify.js";
import "@/sass/main.scss";

import { VueReCaptcha } from "vue-recaptcha-v3";

import VueMasonry from "vue-masonry-css";
import { register } from "vue-advanced-chat";
import { captureAdMeta } from "@/core/utils/adMeta";

// Capture ad/UTM attribution from the landing URL as early as possible,
// before history-mode routing can strip the query string. First-touch:
// won't overwrite a capture from an earlier visit.
captureAdMeta();
register();

ConsoleLogger.LOG_LEVEL = "OFF"; // 'OFF'/'ERROR'/'WARN'/'INFO'

Vue.prototype.$eventBus = new Vue();
Vue.prototype.$eventBus.$emitAsync = function (eventName, payload) {
  return new Promise((resolve, reject) => {
    // Emit the event with a callback for resolving or rejecting
    this.$emit(eventName, payload, resolve, reject);
  });
};

import "./plugins/datastore/config.js";

Amplify.configure({
  ...awsconfig,
  // Auth: {
  //   signUpConfig: {
  //     hiddenDefaults: ["phone_number"],
  //   },
  // },
  API: {
    // Amplify defaults to the ACCESS token, which has no `email` claim.
    // SubscriptionAccess uses `identityClaim: "email"`, so we need the ID token.
    graphql_headers: async () => {
      try {
        const session = await Auth.currentSession();
        return { Authorization: session.getIdToken().getJwtToken() };
      } catch (e) {
        return {}; // signed out -> leave AWS_IAM / API_KEY alone
      }
    },
  },
  DataStore: {
    authModeStrategyType: AuthModeStrategyType.MULTI_AUTH,
    region: "eu-west-2",
  },
  Storage: {
    AWSS3: {
      bucket: "missanriscn-storage-c4dd76e0", //REQUIRED -  Amazon S3 bucket name
      region: "eu-west-2", //OPTIONAL -  Amazon service region
    },
  },
});

DataStore.start();

Vue.use(appConfigPlugin);

Vue.use(VueMasonry);

Vue.use(VTiptap);

Vue.use(VueReCaptcha, {
  siteKey: "6LdMEJMmAAAAAAR969iuiDARS96O0GOtzOqM7QRV",
  loaderOptions: {
    useRecaptchaNet: true,
    autoHideBadge: true,
  },
});

Vue.config.productionTip = false;

Vue.config.ignoredElements = [/amplify-\w*/];

Vue.config.errorHandler = (err, vm, info) => {
  // Log to console instead of showing overlay
  console.error("Error:", err, info);
};

// window.onerror = function() { return true; };

// // Global handler for initial chunk load errors (script tag failures)
// window.onerror = function(msg, url, lineNo, colNo, error) {
//   if (url && url.includes('.chunk.js')) {
//     console.log('Chunk load error detected, reloading...');
//     window.location.reload();
//     return true; // Prevent default error propagation
//   }
//   return false;
// };

// // Global handler for dynamic chunk load errors (webpack promise rejections)
// window.addEventListener('unhandledrejection', (event) => {
//   if (event.reason && event.reason.message && event.reason.message.includes('Loading chunk')) {
//     console.log('Dynamic chunk load error detected, reloading...');
//     window.location.reload();
//     event.preventDefault(); // Prevent default rejection handling
//   }
// });

// // Optional: Also listen for any fetch errors related to chunks (SW-related)
// window.addEventListener('error', (event) => {
//   if (event.message && event.message.includes('chunk') && event.filename && event.filename.includes('.js')) {
//     console.log('Fetch/chunk error detected, reloading...');
//     window.location.reload();
//     event.preventDefault();
//   }
// });

applyPolyfills().then(() => {
  defineCustomElements(window);
});

new Vue({
  router,
  store,
  i18n,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
